import { gql } from '@apollo/client';

export const LESSON_CREATE_MUTATION = gql`
  mutation LessonCreate($input: lessons_insert_input!) {
    insert_lessons_one(object: $input) {
      id
    }
  }
`;
